<template>
  <div class="person-info">
    <div class="title">{{ $t('PCUserInfo.index.647kboa096w0') }}</div>
    <div class="item">
      <div class="item-left">{{ $t('PCUserInfo.index.647kboa09ao0') }}</div>
      <div class="item-right">
        <input
          v-model="form.email"
          type="text"
          :placeholder="$t('PCUserInfo.index.647kboa09u40')"
          @input="inputChange"
        />
        <div v-if="showEmailErrorTip" class="error-tip">
          {{ $t('PCUserInfo.index.647kboa0ak00') }}
        </div>
      </div>
    </div>
    <div class="item">
      <div class="item-left item-left-auto">{{ $t('PCUserInfo.index.647kboa09dk0') }}</div>
      <div class="item-right">
        <div class="input">
          <input
            v-model="form.code"
            type="text"
            :placeholder="$t('PCUserInfo.index.647kboa09u40')"
            @blur="blur"
          />

          <img v-if="isPass" src="@/assets/PC/img/true.png" alt="" class="isPass" />
          <div
            v-else
            :class="['btn', !form.email || timer ? 'gray-btn' : '']"
            @click="sendCode"
          >
            {{ text }}
          </div>
        </div>
        <div v-if="showTip" class="error-tip">
          <!-- {{ $t('PCUserInfo.index.error') }} -->
          {{ showTipText }}
        </div>
      </div>
    </div>
    <div class="declaration">
      <span> {{ $t('PCUserInfo.index.declaration') }}</span>
      <span class="download" @click="download">
        <i class="el-icon-download"></i>
        {{ $t('PCUserInfo.index.download') }}
      </span>
    </div>
  </div>
</template>

<script>
import { vm } from '@/locales';
import { lang } from '@/locales';
import { getChannelId } from '@/utils/channel';

import { getCode, verifyCode } from '../../../services/api/settleAccount';
export default {
  name: 'PersonInfo',
  props: {
    info: Object
  },
  data() {
    return {
      form: {
        email: '',
        code: ''
      },
      timer: null,
      text: vm.$t('PCUserInfo.index.647kboa09z80'),
      isPass: false,
      showTip: false,
      showTipText: '',
      showEmailErrorTip: false,
      alreadySend: false, // 是否发过验证码
      isDownload: false,
      lang,
      channel: getChannelId()
    };
  },
  computed: {
    // downLoadHref() {
    //   return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_vivo_declaration.pdf`;
    // }
    downLoadHref() {
      // 根据渠道和语言返回对应的下载链接
      if (!this.channel || this.channel === '' || this.channel === '100000') {
        // 普通渠道：支持英语、西班牙语、意大利语等
        return `https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/${this.lang}_vivo_declaration.pdf`;
      } else if (this.channel === '100070') {
        // 线上渠道：支持英语和德语
        if (this.lang == 'de') {
          return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_online_devlaration_de.pdf';
        }
        return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_online_devlaration_en.pdf';
      } else if (this.channel === '100080') {
        // 线下渠道：只支持德语
        return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/at_offline_devlaration_de.pdf';
      }
      // 默认返回英语
      return 'https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/en_vivo_declaration.pdf';
    }
  },
  watch: {
    /**
     * 监听表单数据填写
     */
    // form: {
    //   deep: true,
    //   immediate: true,
    //   handler: function (val) {
    //     let flag = Boolean(val && val.email && this.isPass)
    //     let data = {
    //       flag,
    //       form: val
    //     }
    //     this.$emit('completeEmail', data)
    //   }
    // }
  },
  mounted() {
    console.log('emailEnter');
    const textarea = document.querySelector('textarea');
    textarea.addEventListener('input', e => {
      textarea.style.height = '20px';
      textarea.style.height = e.target.scrollHeight + 'px';
    });

    this.isDownload = this.info.isDownload;
    this.isPass = this.info.isPass;
    const { email, code } = this.info;
    this.form = {
      email,
      code
    };

    const data = {
      flag: this.isPass,
      form: this.form
    };
    this.$emit('completeEmail', data, this.isDownload);
  },

  methods: {
    download() {
      // downLoadHref
      fetch(this.downLoadHref)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'declaration.pdf';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // 清理
        });


      const data = {
        flag: this.isPass,
        form: this.form
      };
      this.isDownload = true;
      this.$emit('completeEmail', data, this.isDownload);
    },
    inputChange(val) {
      this.isPass = false;
      const data = {
        flag: false,
        form: this.form
      };
      this.$emit('completeEmail', data, this.isDownload);
    },
    /**
     * 邮箱发送验证码
     */
    sendCode() {
      if (!this.form.email || this.timer) {
        return;
      }
      getCode({ email: this.form.email })
        .then(res => {
          const { code } = res;
          if (code === '0000') {
            this.alreadySend = true;
            const TIME_COUNT = 60;
            if (!this.timer) {
              this.count = TIME_COUNT;
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--;
                  this.text = `${this.$t('PCUserInfo.index.send')}(${this.count}s)`;
                } else {
                  this.text = 'Reenviar';
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        })
        .catch(err => {
          if (err.response.data.code === '201') {
            this.showEmailErrorTip = true;
          }
        });
    },
    /**
     * 失焦验证邮箱验证码
     */
    blur() {
      if (!this.alreadySend) {
        return;
      }
      const data = {
        email: this.form.email,
        verifyCode: this.form.code
      };
      verifyCode(data)
        .then(res => {
          const { code, message } = res;
          if (code === '0000') {
            this.isPass = true;
            const data = {
              flag: true,
              form: this.form
            };
            this.showTip = false;
            this.$emit('completeEmail', data, this.isDownload);
          } else {
            this.showTip = true;
            this.showTipText = message;
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style scoped lang="less">
.declaration {
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  // padding: 0 24px;
  display: flex;
  justify-content: space-between;
  color: #333;
  padding: 30px 0px;
  font-size: 28px;
  .download {
    color: #ff9600;
    cursor: pointer;
  }
}

.person-info {
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  margin-bottom: 24px;
  background: #fff;
  border-radius: 20px;
  padding: 0 24px;
  .title {
    height: 84px;
    font-size: 32px;
    font-weight: 500;
    color: #333;
    line-height: 84px;
  }
  .item {
    padding: 30px 0px 29px 0px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #f4f5f7;
    position: relative;
    .item-left {
      width: 170px;
      font-size: 28px;
      color: #5d5f65;
      margin-right: 32px;
    }
    .item-left-auto {
      width: auto;
      margin-right: 32px;
    }
    .item-right {
      flex: 1;
      color: #333;
      input {
        width: 100%;
        border: none;
        padding: 0;
        font-size: 28px;
        color: #333;
      }
      input::placeholder {
        color: #999;
        font-size: 28px;
      }
      .error-tip {
        color: #f00;
        font-size: 24px;
        position: absolute;
        bottom: 0;
      }
      .input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .btn {
          padding: 12px;
          color: #fff;
          background: #405fff;
          font-size: 24px;
          border-radius: 10px;
        }
        input {
          width: 250px;
        }
        .gray-btn {
          opacity: 0.5;
        }
      }
    }
  }

  .isPass {
    width: 32px;
    height: 32px;
  }

  .item:last-child {
    border-bottom: none;
  }

  .textarea {
    flex: 1;
    width: 100%;
    height: 40px;
    border: none;
    padding: 0;
    font-size: 28px;
    color: #333;
  }
  .textarea::placeholder {
    color: #999;
    font-size: 28px;
  }
}
</style>
